/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */

import {Type} from "@qwoach/class-transformer-wrapper";
import BaseFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/BaseFormElement";
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import {formTriggerValidator} from "@/utils/helpers";
import AnswersItem from "@/core/modules/coach/Resources/Forms/model/FormElements/General/AnswersItem";

export default class FormElementTextGrid extends BaseFormElement {

	columnTitles: string[] = []
	@Type(() => AnswersItem)
	answerOptions: AnswersItem[] = []
	allowAddingOptions: boolean = true
	showHeader: boolean = true


	constructor(title, isRequired) {
		super(FormElementType.TEXT_GRID, title, isRequired);
	}

	resetElement(){
		super.resetElement()
		this.columnTitles = ["Column 1", "Column 2"]
		this.answerOptions = [new AnswersItem()]
		this.syncAnswerOptionsWithColumnsCount()
		this.otherAnswer = null
		this.showOtherOption = false
		this.showScoring = false
		this.enableScoring = false
	}

	getAnswer(){
		return this.answerOptions
	}

	setAnswer(answer){
		if(Array.isArray(answer) && answer.length > 0){
			this.answerOptions = answer
		}
	}



	addRow(){
		this.answerOptions.push(new AnswersItem())
		this.syncAnswerOptionsWithColumnsCount()
	}

	removeRow(index){
		this.answerOptions.splice(index, 1)
	}

	addColumn(){
		this.columnTitles.push("")
		this.syncAnswerOptionsWithColumnsCount()
	}

	removeColumn(index){
		this.columnTitles.splice(index, 1)
		this.syncAnswerOptionsWithColumnsCount()
	}

	syncAnswerOptionsWithColumnsCount(){
		let count = this.columnTitles.length
		console.log("syncAnswerOptionsWithColumnsCount: count = ", count)
		for(let answersItem of this.answerOptions){
			let countChange = count - answersItem.answers.length
			// console.log("syncAnswerOptionsWithColumnsCount: countChange = ", countChange)
			if(countChange > 0){
				while (countChange > 0){
					answersItem.answers.push("")
					countChange--
				}
			} else if(countChange < 0){
				answersItem.answers.splice(count)
			}
		}
	}

	getValidateRules(){
		return formTriggerValidator((value) => {
			let error

			if(this.isRequired){
				for(let answerItem of this.answerOptions){
					for(let text of answerItem.answers){
						if(!text){
							error = "Please fill in all the fields"
							break;
						}
					}
					if(error){
						break
					}
				}
			}


			return error
		})
	}
}
